export default __webpack_public_path__ + "static/media/qualifications-new.cb7d8cad.svg";